import { CoreApi, Product, ProductPartial } from '@inter-ikea-storageone/range';
import { ComponentIds, Entity, GuestConnectionsComponent } from '@inter-ikea-core/core';

export const frameAttachment = (
  coreApi: CoreApi,
  selectedProduct: Product | ProductPartial,
  selectedEntity?: Entity
) => () => {
  const connectorName = selectedEntity?.getComponent<GuestConnectionsComponent>(
    ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID
  )?.highestPriorityConnection?.guestConnector.key;
  return connectorName !== 'attach-to-wall';
};
